module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_f_melanistic.a4767205.png";